module.exports = __webpack_public_path__ + "img/v5.2ac59c81.png";